import React from 'react';
import SearchDataManagerFilterContainer from './SearchDataManagerFilter';

function SearchDataManagerFilter({
  setTabValue,
  setValue,
  setValueCode,
  valueCode,
  setFilterCode,
  setFilterCodeName,
  // setIsCopyRowData={setIsCopyRowData}
  // setUsageState={setUsageState}
  fieldRowData,
  setFieldRowData,
}) {
  return (
    <>
      <div>
        <SearchDataManagerFilterContainer
          setValue={setValue}
          setTabValue={setTabValue}
          valueCode={valueCode}
          setFilterCode={setFilterCode}
          setFilterCodeName={setFilterCodeName}
          //   setIsCopyRowData={setIsCopyRowData}
          // setUsageState={setUsageState}
          fieldRowData={fieldRowData}
          setFieldRowData={setFieldRowData}
        />
      </div>
    </>
  );
}

export default SearchDataManagerFilter;
